import { baseApi } from "./api";

export const adminProjectsApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		listProjectsMemberSummary: build.query({
			query: () => ({
				url: "admin/projects/member-summary",
			}),
			providesTags: [{ type: "AdminProjects", id: "MEMBER_SUMMARY" }],
		}),
	}),
});

export const { useListProjectsMemberSummaryQuery } = adminProjectsApi;
